document.addEventListener('DOMContentLoaded', function() {
  const bundlyComponents = document.querySelectorAll('.bundly__component');

  bundlyComponents.forEach((component, index) => {
    console.log(`Fetching metafields for Bundly component ${index}`);

    // Get the product URL from the anchor (without the variant query parameter)
    const productAnchor = component.querySelector('a');
    let productUrl = productAnchor ? productAnchor.getAttribute('href') : '';
    if (productUrl.includes('?variant=')) {
      productUrl = productUrl.split('?')[0]; // Remove the variant query parameter to get the base product URL
    }

    // Fetch product data, including metafields
    fetch(`${productUrl}.json`)
      .then(response => response.json())
      .then(data => {
        const product = data.product;
        const metafields = product.metafields;

        if (metafields && metafields.length > 0) {
          // Filter metafields by the 'custom' namespace
          const customMetafields = metafields.filter(metafield => metafield.namespace === 'custom');

          if (customMetafields.length > 0) {
            customMetafields.forEach(metafield => {
              console.log('Custom Metafield:', metafield); // Log the metafield for debugging
              const metafieldTitle = metafield.key; // Get the key (like 'metafield_name')
              const metafieldValue = metafield.value; // Get the value

              // You can format the key if you need it to display more cleanly
              const formattedTitle = metafieldTitle.replace(/_/g, ' ').toUpperCase(); // Example: convert 'metafield_name' to 'METAFIELD NAME'

              // Create and append the metafield data to the sidebar
              const metafieldDiv = document.createElement('div');
              metafieldDiv.classList.add('metafield');
              metafieldDiv.innerHTML = `<strong>${formattedTitle}:</strong> ${metafieldValue}`;
              component.appendChild(metafieldDiv); // Append to the component or sidebar
            });
          } else {
            console.log('No custom metafields available for this product.');
          }
        } else {
          console.log('No metafields available for this product.');
        }
      })
      .catch(error => {
        console.error('Error fetching metafields:', error);
      });
  });
});
